import { GET_UESER_STATUS_REPORT } from "../../../Types";
const initialState = {
  UserStatusReport: {}
};

const UsersStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_UESER_STATUS_REPORT:
      return { ...state, UserStatusReport: action.payload, };
    default:
      return state;
  }
};
export default UsersStatusReducer;
